/**
 * Sidebar scroll-spy for the courses detail page sidebar.
 * Toggles a `data-active` attribute on each <li data-sidebar-item="…">
 * based on which content section is currently in the upper portion of
 * the viewport.
 */
const items = Array.from(
    document.querySelectorAll<HTMLElement>('[data-sidebar-item]')
)

if (items.length > 0) {
    const sections: HTMLElement[] = []
    const sectionByHash = new Map<string, HTMLElement>()

    items.forEach((item) => {
        const hash = item.dataset.sidebarItem
        if (!hash) return
        const section = document.getElementById(hash)
        if (!section) return
        sections.push(section)
        sectionByHash.set(hash, section)
    })

    const setActive = (hash: string) => {
        items.forEach((item) => {
            const isActive = item.dataset.sidebarItem === hash
            item.toggleAttribute('data-active', isActive)
        })
    }

    if (sections.length > 0) {
        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((e) => e.isIntersecting)
                    .map((e) => ({
                        hash: (e.target as HTMLElement).id,
                        top: e.boundingClientRect.top,
                    }))
                    .sort((a, b) => a.top - b.top)
                if (visible.length > 0) setActive(visible[0].hash)
            },
            {
                rootMargin: '-15% 0px -60% 0px',
                threshold: 0,
            }
        )

        sections.forEach((section) => observer.observe(section))

        // Eagerly mark the link as active on click so the indicator moves immediately
        // (the IntersectionObserver will reconfirm on scroll completion).
        items.forEach((item) => {
            const link = item.querySelector<HTMLAnchorElement>('a[href^="#"]')
            if (!link) return
            link.addEventListener('click', () => {
                const hash = item.dataset.sidebarItem
                if (hash) setActive(hash)
            })
        })
    }
}
